import { render, staticRenderFns } from "./OAuthChannel.vue?vue&type=template&id=757a9a58&"
import script from "./OAuthChannel.vue?vue&type=script&setup=true&lang=js&"
export * from "./OAuthChannel.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('757a9a58')) {
      api.createRecord('757a9a58', component.options)
    } else {
      api.reload('757a9a58', component.options)
    }
    module.hot.accept("./OAuthChannel.vue?vue&type=template&id=757a9a58&", function () {
      api.rerender('757a9a58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/inbox/channels/emailChannels/OAuthChannel.vue"
export default component.exports